$mol_view_tree2_to_js_test_ex_bidi_localized_in_object_foo $mol_object
	obj *
		loc? <=> outer? @ \test1
